import { useEffect } from "react";
import { withRouter } from "react-router-dom";

export default withRouter(({ location }) => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);
  return null;
});
